const resources = {
  "en": {
    "recurrentHub": {
      "title": "Recurring hub",
      "description": "Manage recurring income and expense setups from one calm entry screen without changing the existing recurrent flows.",
      "headerMeta": "Recurring entry and registry view",
      "actionsTitle": "Recurring actions",
      "actionsDescription": "Open a new recurring expense or recurring income flow from the same entry area.",
      "addExpense": "Add recurring expense",
      "addIncome": "Add recurring income",
      "recentTitle": "Recent recurring items",
      "recentDescription": "Review the latest recurring setups, their cadence, and their linked accounts.",
      "expenseModalTitle": "Add recurring expense",
      "incomeModalTitle": "Add recurring income",
      "expenseEditTitle": "Edit recurring expense",
      "incomeEditTitle": "Edit recurring income",
      "expenseSuccess": "Recurring expense saved.",
      "incomeSuccess": "Recurring income saved.",
      "expenseUpdateSuccess": "Recurring expense updated.",
      "incomeUpdateSuccess": "Recurring income updated.",
      "empty": "No recurring operations yet. Add one to start forecasting.",
      "loadError": "Unable to load recurring items.",
      "unnamed": "Recurring item",
      "edit": "Edit",
      "pause": "Pause",
      "resume": "Resume",
      "pauseSuccess": "Recurring item paused.",
      "resumeSuccess": "Recurring item resumed.",
      "lifecycleError": "Unable to update recurring item status.",
      "status": {
        "active": "Active",
        "paused": "Paused"
      },
      "type": {
        "expense": "Recurring expense",
        "income": "Recurring income",
        "planPayment": "Auto · based on repayment plan"
      },
      "frequency": {
        "daily": "Daily",
        "weekly": "Weekly",
        "biWeekly": "Bi-weekly",
        "monthly": "Monthly",
        "yearly": "Yearly"
      },
      "metrics": {
        "totalItems": "Recurring items",
        "totalItemsMeta_one": "{{count}} active setup in this registry",
        "totalItemsMeta_other": "{{count}} active setups in this registry",
        "expenseItems": "Expense setups",
        "expenseItemsMeta_one": "{{count}} expense setup",
        "expenseItemsMeta_other": "{{count}} expense setups",
        "incomeItems": "Income setups",
        "incomeItemsMeta_one": "{{count}} income setup",
        "incomeItemsMeta_other": "{{count}} income setups",
        "linkedAccounts": "Linked accounts",
        "linkedAccountsMeta_one": "{{count}} account currently available",
        "linkedAccountsMeta_other": "{{count}} accounts currently available",
        "autoPlanPayments": "Auto plan payments",
        "autoPlanPaymentsMeta_one": "{{count}} generated installment from repayment plans",
        "autoPlanPaymentsMeta_other": "{{count}} generated installments from repayment plans"
      },
      "meta": {
        "startDate": "Starts {{date}}",
        "dueDate": "Due {{date}}",
        "source": "Source: {{source}}",
        "target": "Target: {{account}}",
        "planOccurrence": "Generated occurrence",
        "planEditHint": "Change future installments from the repayment plan."
      },
      "actions": {
        "openObligations": "Open obligations"
      },
      "taxStatus": {
        "pre": "Pre-tax",
        "post": "Post-tax"
      },
      "form": {
        "description": "Description",
        "descriptionPlaceholder": "Name this recurring item",
        "amount": "Amount",
        "startDate": "Start date",
        "frequency": "Frequency",
        "source": "Source account",
        "sourcePlaceholder": "Choose a source account",
        "targetAccount": "Target account",
        "targetAccountPlaceholder": "Choose a target account",
        "currencyMissing": "Currency missing",
        "vendor": "Vendor",
        "vendorPlaceholder": "Optional vendor or merchant",
        "taxStatus": "Tax status",
        "taxStatusPlaceholder": "Select a tax status",
        "save": "Save",
        "cancel": "Cancel"
      },
      "fallbacks": {
        "unknownAccount": "Unknown account"
      },
      "accountsLoadError": "Unable to load accounts.",
      "saveError": "Unable to save the recurring item."
    }
  },
  "uk": {
    "recurrentHub": {
      "title": "Хаб регулярних операцій",
      "description": "Керуй регулярними доходами та витратами з одного спокійного entry screen без зміни наявних recurrent flows.",
      "headerMeta": "Перегляд входу та реєстру регулярних операцій",
      "actionsTitle": "Регулярні дії",
      "actionsDescription": "Запускай новий сценарій регулярної витрати або регулярного доходу з однієї зони входу.",
      "addExpense": "Додати регулярну витрату",
      "addIncome": "Додати регулярний дохід",
      "recentTitle": "Останні регулярні записи",
      "recentDescription": "Переглядай останні регулярні налаштування, їхню періодичність і пов’язані рахунки.",
      "expenseModalTitle": "Додати регулярну витрату",
      "incomeModalTitle": "Додати регулярний дохід",
      "expenseEditTitle": "Редагувати регулярну витрату",
      "incomeEditTitle": "Редагувати регулярний дохід",
      "expenseSuccess": "Регулярну витрату збережено.",
      "incomeSuccess": "Регулярний дохід збережено.",
      "expenseUpdateSuccess": "Регулярну витрату оновлено.",
      "incomeUpdateSuccess": "Регулярний дохід оновлено.",
      "empty": "Поки немає регулярних операцій. Додайте, щоб почати прогнозування.",
      "loadError": "Не вдалося завантажити регулярні записи.",
      "unnamed": "Регулярний запис",
      "edit": "Редагувати",
      "pause": "Призупинити",
      "resume": "Відновити",
      "pauseSuccess": "Регулярний запис призупинено.",
      "resumeSuccess": "Регулярний запис відновлено.",
      "lifecycleError": "Не вдалося оновити статус регулярного запису.",
      "status": {
        "active": "Активний",
        "paused": "Призупинений"
      },
      "type": {
        "expense": "Регулярна витрата",
        "income": "Регулярний дохід",
        "planPayment": "Авто · на основі плану погашення"
      },
      "frequency": {
        "daily": "Щодня",
        "weekly": "Щотижня",
        "biWeekly": "Раз на два тижні",
        "monthly": "Щомісяця",
        "yearly": "Щороку"
      },
      "metrics": {
        "totalItems": "Регулярні записи",
        "totalItemsMeta_one": "{{count}} активне налаштування в цьому реєстрі",
        "totalItemsMeta_few": "{{count}} активні налаштування в цьому реєстрі",
        "totalItemsMeta_many": "{{count}} активних налаштувань у цьому реєстрі",
        "totalItemsMeta_other": "{{count}} активних налаштувань у цьому реєстрі",
        "expenseItems": "Налаштування витрат",
        "expenseItemsMeta_one": "{{count}} налаштування витрати",
        "expenseItemsMeta_few": "{{count}} налаштування витрат",
        "expenseItemsMeta_many": "{{count}} налаштувань витрат",
        "expenseItemsMeta_other": "{{count}} налаштувань витрат",
        "incomeItems": "Налаштування доходів",
        "incomeItemsMeta_one": "{{count}} налаштування доходу",
        "incomeItemsMeta_few": "{{count}} налаштування доходів",
        "incomeItemsMeta_many": "{{count}} налаштувань доходів",
        "incomeItemsMeta_other": "{{count}} налаштувань доходів",
        "linkedAccounts": "Пов’язані рахунки",
        "linkedAccountsMeta_one": "{{count}} рахунок зараз доступний",
        "linkedAccountsMeta_few": "{{count}} рахунки зараз доступні",
        "linkedAccountsMeta_many": "{{count}} рахунків зараз доступно",
        "linkedAccountsMeta_other": "{{count}} рахунків зараз доступно",
        "autoPlanPayments": "Автоплатежі за планом",
        "autoPlanPaymentsMeta_one": "{{count}} створений платіж із плану погашення",
        "autoPlanPaymentsMeta_few": "{{count}} створені платежі з планів погашення",
        "autoPlanPaymentsMeta_many": "{{count}} створених платежів із планів погашення",
        "autoPlanPaymentsMeta_other": "{{count}} створених платежів із планів погашення"
      },
      "meta": {
        "startDate": "Початок {{date}}",
        "dueDate": "Термін {{date}}",
        "source": "Джерело: {{source}}",
        "target": "Ціль: {{account}}",
        "planOccurrence": "Створений occurrence",
        "planEditHint": "Майбутні платежі змінюються через план погашення."
      },
      "actions": {
        "openObligations": "Відкрити зобов’язання"
      },
      "taxStatus": {
        "pre": "До сплати податків",
        "post": "Після сплати податків"
      },
      "form": {
        "description": "Опис",
        "descriptionPlaceholder": "Дайте назву регулярному запису",
        "amount": "Сума",
        "startDate": "Дата початку",
        "frequency": "Періодичність",
        "source": "Рахунок джерела",
        "sourcePlaceholder": "Оберіть рахунок",
        "targetAccount": "Цільовий рахунок",
        "targetAccountPlaceholder": "Оберіть цільовий рахунок",
        "currencyMissing": "Немає валюти",
        "vendor": "Постачальник",
        "vendorPlaceholder": "Необовʼязковий продавець",
        "taxStatus": "Статус оподаткування",
        "taxStatusPlaceholder": "Оберіть статус",
        "save": "Зберегти",
        "cancel": "Скасувати"
      },
      "fallbacks": {
        "unknownAccount": "Невідомий рахунок"
      },
      "accountsLoadError": "Не вдалося завантажити рахунки.",
      "saveError": "Не вдалося зберегти регулярний запис."
    }
  }
};

export default resources;
